import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Accordion,
} from "react-bootstrap";
import { EntypoMagnifyingGlass } from "react-entypo-icons";
import "./RestaurantFoodSelection.css";
import { primaryColor } from "../../config/colors";
import { strings } from "../../localization";
import {
  getFoodDataFromStorage,
  getOrganisationId,
  getTotalPriceOfFoodItem,
} from "../../config";
import Loading from "../../components/Loading";
import CustomNavbar from "../../components/navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { withRouter } from "react-router-dom";
import { getFoodCategory } from "../../api/ApiServices";
import EmptyOrderComponent from "../../components/EmptyOrderComponent";

function RestaurantFoodSelectionReadOnly() {
  const [search, setSearch] = useState("");
  const [foodList, setFoodList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getTotalItems = () => {
    console.log("food List", foodList);
    const totalItems = foodList.reduce((categoryAcc, category) => {
      console.log("category", category);
      return (
        categoryAcc +
        category.items.reduce(
          (itemAcc, item) => itemAcc + Number(item.quantity),
          0
        )
      );
    }, 0);
    return totalItems;
  };

  const getFoodItemsCategory = () => {
    setIsLoading(true);
    const parsedFoodItems = JSON.parse(getFoodDataFromStorage());
    console.log("DEV-100 parsedFoodItems", parsedFoodItems);
    const organisationID = getOrganisationId();
    // Change this to dynamic once ready
    getFoodCategory(organisationID)
      .then(async (res) => {
        const parsedJson = await res.json();
        console.log("parsed json", parsedJson);
        console.log("parsed json", Array.isArray(parsedJson));
        if (res.status === 200) {
          if (parsedJson && Array.isArray(parsedJson)) {
            let result = parsedJson.map((group) => ({
              ...group,
              items: group.items.map((item) => ({
                ...item,
                quantity: "0",
                note: "",
              })),
            }));
            if (parsedFoodItems && parsedFoodItems.length > 0) {
              console.log("DEV-100 in if condition");
              result = result.map((category) => {
                const matchingCategory = parsedFoodItems.find(
                  (addedCategory) => addedCategory._id === category._id
                );
                console.log("DEV-100 matchingCategory", matchingCategory);
                const updatedItems = category.items.map((item) => {
                  if (!matchingCategory) return item;

                  const addedItem = matchingCategory.items.find(
                    (added) => added.itemID === item.itemID
                  );

                  if (addedItem) {
                    return {
                      ...item,
                      quantity: addedItem.quantity,
                      note: addedItem.note,
                    };
                  }
                  return item;
                });
                console.log("DEV-100 updatedItems", updatedItems);

                return {
                  ...category,
                  items: updatedItems,
                };
              });
            }
            console.log("DEV-100 result", result);
            setFoodList(result);
          }
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("catch block error while getting food category", err);
        setIsLoading(false);
      });
  };

  const filterFoodItems = (foodItems, searchQuery) => {
    const query = searchQuery.trim().toLowerCase();

    if (query === "") return foodItems;

    return foodItems
      .map((category) => {
        const matchedCategoryName = category.name.toLowerCase().includes(query);

        const filteredItems = category.items.filter(
          (item) =>
            item.name.toLowerCase().includes(query) ||
            item.description.toLowerCase().includes(query)
        );

        if (matchedCategoryName || filteredItems.length > 0) {
          return {
            ...category,
            items:
              matchedCategoryName && filteredItems.length === 0
                ? category.items
                : filteredItems,
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  const filteredCategories = useMemo(() => {
    console.log("DEBUG foodList in categories", foodList);
    return filterFoodItems(foodList, search);
  }, [foodList, search]);

  useEffect(() => {
    getFoodItemsCategory();
  }, []);

  return (
    <div className="d-flex flex-column vh-100 overflow-hidden">
      {/* Header Section */}
      <Container fluid className="sticky-top shadow-sm">
        <CustomNavbar pageName={strings.select_food} />
        <div style={{ backgroundColor: primaryColor }}>
          <InputGroup className="px-2 pb-2 py-2">
            <InputGroup.Text>
              <EntypoMagnifyingGlass />
            </InputGroup.Text>
            <Form.Control
              placeholder={`${strings.search_for_food}...`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ border: 0 }}
            />
          </InputGroup>
        </div>
      </Container>

      {isLoading ? (
        <Loading />
      ) : (
        <div
          className="flex-grow-1 foodItemsContainer"
          style={{
            maxHeight: `calc(${
              getTotalItems() > 0 ? "93vh" : "100vh"
            } - 150px)`,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {foodList.length === 0 ? (
            <div className="text-center text-muted my-4">
              <EmptyOrderComponent title={strings.empty_food_data_msg} />
            </div>
          ) : filteredCategories.length === 0 ? (
            <div className="text-center text-muted my-4">
              <EntypoMagnifyingGlass
                className="mb-2"
                style={{ fontSize: 25 }}
              />
              <div>{strings.no_food_item_seach_found_msg}</div>
            </div>
          ) : (
            filteredCategories.map((foodItem, index) => {
              if (foodItem.items && foodItem.items.length > 0) {
                return (
                  <Accordion style={{ marginTop: 10 }}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>{foodItem.name}</Accordion.Header>
                      <Accordion.Body className="p-0">
                        <div>
                          <Row>
                            {foodItem.items.map((item) => (
                              <Col
                                xs={6}
                                sm={6}
                                md={4}
                                key={item.itemID}
                                className="foodItemCard p-0"
                              >
                                <Card className="foodSelectionCardContainer h-100">
                                  <Card.Body className="px-4 py-3">
                                    <div className="foodItemCardBodyContentContainer">
                                      {/* LEFT: Food Info */}
                                      <div style={{ flex: 1, minWidth: 0 }}>
                                        <Card.Title
                                          className="fw-bold mb-1 truncate-multiline"
                                          style={{
                                            fontSize: 15,
                                            lineHeight: "1.2rem",
                                            color: "#222222",
                                          }}
                                        >
                                          {item.name}
                                        </Card.Title>
                                        <Card.Text
                                          className="mb-1 truncate-threeline"
                                          style={{ fontSize: 12 }}
                                        >
                                          {item.description}
                                        </Card.Text>
                                      </div>

                                      <div className="foodItemPriceQtyContainer">
                                        <h5
                                          className="my-2 p-0"
                                          style={{
                                            color: primaryColor,
                                            fontSize: 16,
                                          }}
                                        >
                                          {getTotalPriceOfFoodItem(
                                            item.price,
                                            item.quantity
                                          )}
                                        </h5>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                );
              }
            })
          )}
        </div>
      )}
      <Footer />
    </div>
  );
}

export default withRouter(RestaurantFoodSelectionReadOnly);
